import React__default, { useState } from 'react';
import { Toast } from './Toast.es.js';
import { useTransition, animated } from 'react-spring';

const ToastContextMobile = React__default.createContext({});
const ToastProviderMobile = ({ children, }) => {
    const [toastProps, setToastProps] = useState(null);
    const open = (props) => {
        if (toastProps && JSON.stringify(toastProps) === JSON.stringify(props)) {
            return;
        }
        setToastProps(props);
    };
    const toast = {
        open,
    };
    ['success', 'info', 'error', 'warning'].forEach((type) => {
        toast[type] = (props) => open(Object.assign({ type }, props));
    });
    const onClose = () => setToastProps(null);
    const transitions = useTransition(toastProps, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { tension: 125, friction: 20, precision: 0.1 },
    });
    return (React__default.createElement(ToastContextMobile.Provider, { value: toast },
        children,
        toastProps &&
            transitions((style, item) => item && (React__default.createElement(animated.div, { style: style },
                React__default.createElement(Toast, Object.assign({}, item, { onClose: onClose })))))));
};

export { ToastContextMobile, ToastProviderMobile };
